import utils from '../libs/utils';
import axios from './axios';

const baseUrl = 'v1/erp-business-web';

export default {
  axios,
  // 供应商退货列表
  refundList(params) {
    return axios.get(`${baseUrl}/purchaseRefund/list?${utils.exchangeParams(params)}`);
  },
  // 导出Excel
  downloadExcel(params) {
    return axios.get(`${baseUrl}/purchaseRefund/list/download?${utils.exchangeParams(params)}`);
  },
  // 表单页面-下拉供应商名称列表
  querySupplierList() {
    return axios.get(`${baseUrl}/purchaseRefund/listSupplierInfo`);
  },
  // 获取商品
  queryRefundGoods(params) {
    return axios.get(`${baseUrl}/purchaseRefund/listRefundGoods?${utils.exchangeParams(params)}`);
  },
  // 保存退货单
  purchaseRefundAdd(params) {
    return axios.post(`${baseUrl}/purchaseRefund/add`, utils.exchangeParams(params));
  },
  // 提交退货单
  purchaseRefundAddAndSubmit(params) {
    return axios.post(`${baseUrl}/purchaseRefund/addAndSubmit`, utils.exchangeParams(params));
  },
  // 编辑-保存退货单
  purchaseRefundEdit(params) {
    return axios.post(`${baseUrl}/purchaseRefund/edit`, utils.exchangeParams(params));
  },
  // 编辑-提交退货单
  purchaseRefundSubmit(params) {
    return axios.post(`${baseUrl}/purchaseRefund/submit`, utils.exchangeParams(params));
  },
  // 获取退货单信息
  purchaseRefundInfo(params) {
    return axios.get(`${baseUrl}/purchaseRefund/info?${utils.exchangeParams(params)}`);
  },
  // 删除退货单
  purchaseRefundDelete(params) {
    return axios.post(`${baseUrl}/purchaseRefund/delete`, utils.exchangeParams(params));
  },
  // financeChart/getPurchaseRefundChart
  // 获取退货单图表
  purchaseRefundChart(params) {
    return axios.get(`${baseUrl}/financeChart/getPurchaseRefundChart?${utils.exchangeParams(params)}`);
  },
  // 关联上下查询单据
  purchaseRefundChartLinkInfo(params) {
    return axios.get(`${baseUrl}/financeChart/getInfoAroundPurchaseRefund?${utils.exchangeParams(params)}`);
  },
  saveRefundBill(params) {
    return axios.post(`${baseUrl}/purchaseSupplierRefund/save/refund/bill`, utils.exchangeParams(params));
  },
  submitRefundBill(params) {
    return axios.post(`${baseUrl}/purchaseSupplierRefund/submit/refund/bill`, utils.exchangeParams(params));
  },
  querySingleBill(params) {
    return axios.get(`${baseUrl}/purchaseSupplierRefund/query/single/bill?${utils.exchangeParams(params)}`);
  },
  modifyRefundBill(params) {
    return axios.post(`${baseUrl}/purchaseSupplierRefund/modify/refund/bill`, utils.exchangeParams(params));
  },
  submitModifyRefundBill(params) {
    return axios.post(`${baseUrl}/purchaseSupplierRefund/submit/modify/refund/bill`, utils.exchangeParams(params));
  },
  createPayableBill(params) {
    return axios.post(`${baseUrl}/purchaseSupplierRefund/create/payable/bill`, utils.exchangeParams(params));
  },
  queryAssociatedBill(params) {
    return axios.get(`${baseUrl}/purchaseSupplierRefund/query/associated/bill?${utils.exchangeParams(params)}`);
  },
  purchaseRefundPrint(params) {
    return axios.get(`${baseUrl}/purchaseRefund/print?${utils.exchangeParams(params)}`);
  },
  confirmDelivery(params) {
    return axios.get(`${baseUrl}/purchaseRefund/confirmDelivery?${utils.exchangeParams(params)}`);
  },
  cancelRefund(params) {
    return axios.get(`${baseUrl}/purchaseRefund/cancelDelivery?${utils.exchangeParams(params)}`);
  },
};
